module.exports = __webpack_public_path__ + "img/4_revenue_builder.2956bec5.png";